import { SAVE_ORDER_FEE } from "../constants";

export const saveOrderFeeAction = ({ data }: { data: any }) => {
  return {
    type: SAVE_ORDER_FEE,
    data,
  };
};
